export default "__VITE_ASSET__DAl_0Jf8__"